import { useAppStore } from '@/stores/appStore'
import { BugReporter } from './BugReporter'

export function OfflineBanner() {
  const online = useAppStore((s) => s.online)
  return (
    <>
      {!online && (
        <div
          className="sticky top-0 z-40 flex items-center justify-center gap-2 py-1.5 text-caption"
          style={{ background: '#D4A24C', color: '#0B0F0E' }}
        >
          <span className="inline-block h-1.5 w-1.5 rounded-full bg-current" />
          <span className="font-medium">Offline — your entries save locally and sync when you reconnect</span>
        </div>
      )}
      <BugReporter />
    </>
  )
}
